import { useQuery } from '@apollo/client'
import { useEffect, useState } from 'react'

import {
  Drawer,
  DrawerBody,
  DrawerCloseButton,
  DrawerContent,
  DrawerHeader,
  DrawerOverlay,
  Stack,
  Table,
  TableContainer,
  Tag,
  Tbody,
  Text,
  Th,
  Thead,
  Tr
} from '@chakra-ui/react'

import CustomLoader from 'components/CustomLoader'
import VulLinkRow from 'components/Tables/VulLinkRow'

import { ComponentVulnLogs } from 'graphQL/Queries'

const StatusHistory = (props) => {
  const { data, isOpen, onClose } = props
  const { id, vulnId } = data || ''
  const [sortedData, setSortedData] = useState([])

  const { data: logs, loading } = useQuery(ComponentVulnLogs, {
    variables: { vexLogableId: id }
  })

  const { componentVulnLogs } = logs || ''

  useEffect(() => {
    if (componentVulnLogs?.length > 0) {
      const sorted = [...componentVulnLogs].sort(
        (a, b) => new Date(b.updatedAt) - new Date(a.updatedAt)
      )
      setSortedData(sorted)
    }
  }, [componentVulnLogs])

  return (
    <Drawer size='md' isOpen={isOpen} placement='right' onClose={onClose}>
      <DrawerOverlay />
      <DrawerContent>
        <DrawerCloseButton mt={2} />
        <DrawerHeader borderBottomWidth='1px'>
          <Text mb={1} fontWeight={'medium'}>
            Status History
          </Text>
          {vulnId && <Tag colorScheme='blue'>{vulnId}</Tag>}
        </DrawerHeader>
        <DrawerBody>
          {loading ? (
            <CustomLoader />
          ) : (
            <Stack>
              {componentVulnLogs?.length > 0 ? (
                <TableContainer width={'100%'}>
                  <Table variant='simple'>
                    <Thead>
                      <Tr>
                        {['STATUS', 'BY', ''].map((item, index) => (
                          <Th
                            key={index}
                            color={'#718096'}
                            fontWeight={'medium'}
                            fontFamily={'inherit'}
                            isNumeric={item === ''}
                            pl={index === 0 ? 0 : 'auto'}
                          >
                            {item}
                          </Th>
                        ))}
                      </Tr>
                    </Thead>
                    <Tbody>
                      {sortedData?.map((item, index) => (
                        <VulLinkRow key={index} data={item} />
                      ))}
                    </Tbody>
                  </Table>
                </TableContainer>
              ) : (
                <Text mt={4} color={'gray.500'}>
                  There are no records to display
                </Text>
              )}
            </Stack>
          )}
        </DrawerBody>
      </DrawerContent>
    </Drawer>
  )
}

export default StatusHistory
